import { 
    useMutation, 
    useQuery 
} from "@tanstack/react-query";
import { getMe, login, logout, type LoginPayload, type LoginResponse, type MeResponse } from "../../api/auth/authApi";


export const useLogin = () => {
    return useMutation({
        mutationFn: async (credentials: LoginPayload): Promise<LoginResponse> => {
            const response = await login(credentials);
            return response;
        },
    });
};

export  const useGetMe = () => {
    const token =
        typeof window !== 'undefined' && window.localStorage
            ? window.localStorage.getItem('access_token')
            : null;

    return useQuery({
        queryKey: ['me'],
        queryFn: async (): Promise<MeResponse> => {
            const response = await getMe();
            return response;
        },
        enabled: !!token,
        // retry: false,
    });
};

export const useLogout = () => {
    return useMutation({
        mutationFn: async () => {
            const response = await logout();
            return response;
        },
    });
}